// extracted by mini-css-extract-plugin
export default {"toggles":"UserModal_toggles__9+B1X","checkboxLabel":"UserModal_checkboxLabel__WJeW4","checkbox":"UserModal_checkbox__n7OWJ"};